
  import { css } from 'lit';
  export const styles = css`:host{--diameter: var(--ig-circular-bar-diameter, 3.375rem);--ig-theme: bootstrap;--ig-theme-variant: light}`;
  